import React, { use, useEffect, useState } from "react";
import { CiSearch } from "react-icons/ci";
import { CiStar } from "react-icons/ci";
import { BiBookReader } from "react-icons/bi";
import { PiFireExtinguisherLight } from "react-icons/pi";
import { BiSolidBlanket } from "react-icons/bi";
import { TbBatteryCharging2 } from "react-icons/tb";
import JourneyDailog from "../JourneyDailogs/JourneyDailog";
import { Tooltip, useMediaQuery } from "@mui/material";
import JourneyDailogSmallScreen from "../JourneyDailogs/JourneyDailogSmallScreen";
import { usePath } from "../CommonGlobals/PathContext";
import { set } from "lodash";
import { useAppGlobalState } from "../CommonGlobals/Store";
import JourneyRoundTripDailog from "../JourneyDailogs/JourneyRoundTripDailog";
import JourneyRoundTripDailogSmallScreen from "../JourneyDailogs/JourneyRoundTripDailogSmallScreen";
import DraggableDialog from "../CommonGlobals/ConfirmDialog";

const RouteCardNew = ({
  routeobject,
  paymentUrl = "/payments",
  journeytype,
  handleTabChangeInDialog,
  journeyDialogOpen,
  setJourneyDialogOpen,
  activeJourneyId,        // NEW
  setActiveJourneyId,  
}) => {
  const [item, setItem] = useState(null);

  const [dialogData, setDialogData] = useState(null);

  const [currentTab, setCurrentTab] = useState(0);
  const isSmallScreen = useMediaQuery("(max-width:900px)");
  const [currentJourneyType, setCurrentJourneyType] = useState(journeytype);
  const [globalData, setGlobalData] = useAppGlobalState();
  const { paths } = usePath();
  const [onwardDailogData, setOnwardDialogData] = useState(null);
  const [returnDailogData, setReturnDialogData] = useState(null);

  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [confirmDialogMessage, setConfirmDialogMessage] = useState("Are you sure you want to close Journey Details?");
  const [confirmationResult, setConfirmationResult] = useState(null);

  
  //console.log(paths);


  useEffect(()=>{
    if(confirmationResult != null){

      // console.log("confirmationResult changed in route card");
      // console.log(confirmationResult);
      // setJourneyDailogOpen(!confirmationResult);
      // setShowConfirmDialog(false);

    }
    
  },[confirmationResult]);


  useEffect(() => {
    console.log("showConfirmDialog changed in route card");
    console.log(showConfirmDialog);    
  },[showConfirmDialog]);







  //  const handleNativeClick = (event) => {
  //          console.log("Received data from React Native:", event.detail);
  //          console.log("Current open state:", journeyDialogOpen);
  //          setJourneyDialogOpen((currentOpenState) => {
  //             console.log("Current open state inside setJourneyDialogOpen:", currentOpenState);
  //             if(currentOpenState == true){
  //               // const userConfirmed = window.confirm("Are you sure you want to close Journey Details?");
  //               // if(userConfirmed){
  //               //   return false;
  //               // }else{
  //               //   return true;
  //               // }
  //               // setJourneyDailogOpen(false);
  //               //setShowConfirmDialog(true);
  //               return false; 
                


  //             }else{


  //               console.log("global data value");

  //               console.log(globalData);


  //               // setGlobalData((prev) => {
  //               //   if(prev.isSmallSearchOpen == false){

               
                      
                    
  //               //      return prev;
  //               //   }
  //               // });
                           
                
                
  //               return false;
  //             }
              
  //          });
  
           
          
          
  //          //alert("Header was clicked in the app! Data action: " + event.detail.action);
  //       };
  
  
  //   useEffect(() => {    
  
  //       window.addEventListener('nativeHeaderClick', handleNativeClick);
  
  //       return () => {
  //         window.removeEventListener('nativeHeaderClick', handleNativeClick);
  //       };
  
  
  //   },[]);

    // const isThisCardOpen = journeyDialogOpen && activeJourneyId === item?.JourneyID;

  useEffect(() => { 
    
    const handleNativeClick = (event) => {
      console.log("Received data from React Native:", event.detail);
      // Update parent state directly when the native header is clicked
      setJourneyDialogOpen(false); 
    };

    window.addEventListener('nativeHeaderClick', handleNativeClick);
    return () => {
      window.removeEventListener('nativeHeaderClick', handleNativeClick);
    };
  }, [setJourneyDialogOpen]);

  useEffect(() => {
  //  console.log("routeobject");
   // console.log(routeobject);
    // setItem(routeobject.routeobject);
    //console.log('routeobject changed in route card');
    // console.log(routeobject);
    setItem(routeobject);

    // console.log(item);
  }, [routeobject]);



  useEffect(() => {
   // console.log("dialog data changed in route card");
  //  console.log(globalData);

    // console.log('dialog data changed in route card');

    if (globalData.isReturnJourneyExist) {
     // console.log("It is true that return journey exist in route card");
      if (globalData.journeyType == "onward") {
      //  console.log("dialog data changed in card for onward");
        setOnwardDialogData(dialogData);
        setGlobalData((prev) => {
          
          const nextObject = dialogData || prev?.onwardJourneyObject;

        // console.log("next object is here ")
        // console.log(nextObject);
       //  console.log("previous object")
       //  console.log(prev);


         if(nextObject != null ){

          if( nextObject?.bus.JourneyID == prev?.onwardJourneyObject?.bus?.JourneyID ){
            return prev;
          }else{

            return {
            ...prev,
          onwardJourneyObject: dialogData
            ? dialogData
            : prev.onwardJourneyObject,
              onwarJourneyData:null,
            onwardSelectedSeats:null,
            onwardBoardingPoint:null,
            onwardBoardingName:null,
            onwardDropingPoint:null,
            onwardDropingName:null,
          }

          }

         }else{
          return { ...prev}
         }
          


         
         



        });
      }
      if (globalData.journeyType == "return") {
       // console.log("dialog data changed in card for return");
        setReturnDialogData(dialogData);

                setGlobalData((prev) => {
          
          const nextObject = dialogData || prev?.returnJourneyObject;

        // console.log("next object is here ")
        // console.log(nextObject);
       //  console.log("previous object")
       //  console.log(prev);


         if(nextObject != null ){

          if( nextObject?.bus.JourneyID == prev?.returnJourneyObject?.bus?.JourneyID ){
            return prev;
          }else{

            return {
            ...prev,
          returnJourneyObject: dialogData
            ? dialogData
            : prev.returnJourneyObject,
              returnJourneyData:null,
            returnSelectedSeats:null,
            returnBoardingPoint:null,
            returnBoardingName:null,
            returnDropingPoint:null,
            returnDropingName:null,
          }

          }

         }else{
          return { ...prev}
         }      
   })
        // setGlobalData((prev) => ({
        //   ...prev,
        //   returnJourneyObject: dialogData
        //     ? dialogData
        //     : prev.returnJourneyObject,
         
        // }));
      }
    }

    // console.log('dialog data changed in route card');
    // console.log("dialog data : " + JSON.stringify(dialogData));

    // console.log(
    //   "global data in route card : " + JSON.stringify(globalData)
    // );
  }, [dialogData]);

  useEffect(() => {
    // console.log("item changed in route card");
    // console.log(item);
    // console.log(globalData.journeyType);
    // console.log(globalData.isReturnJourneyExist);

    if (globalData.isReturnJourneyExist) {
      //console.log("It is true that return journey exist in route card");
      if (globalData.journeyType == "onward") {
       // console.log("item changed in card for onward");
        setOnwardDialogData(
          item
            ? { bus: item, journeyDataUrl: "/seatArrangementdirectdata.json" }
            : null,
        );
      //  console.log("item changed in card for onward");
        //console.log(item);
      }
      if (globalData.journeyType == "return") {
        setReturnDialogData(
          item
            ? { bus: item, journeyDataUrl: "/seatArrangementdirectdata.json" }
            : null,
        );
       // console.log("item changed in card for return");
        // console.log(item);
      }
    }
  }, [item]);

  useEffect(() => {
  //  console.log("onward data in card");
   // console.log(onwardDailogData);
  }, [onwardDailogData]);

  useEffect(() => {
  //  console.log("return data in card");
  //  console.log(returnDailogData);
  }, [returnDailogData]);

  useEffect(() => {
    // console.log('journeytype changed in route card');
   // console.log(journeytype);

    setCurrentJourneyType(journeytype);
  }, [journeytype]);

  useEffect(() => {
    console.log('journeyDialogOpen changed in route card');
    console.log(journeyDialogOpen);
  }, [journeyDialogOpen]);

  useEffect(() => {
    // console.log(currentTab);
  }, [currentTab]);
  useEffect(() => {
    // console.log(paymentUrl);
  }, [paymentUrl]);

  const handleMenuClick = (menu) => {
    // console.log(menu);

    switch (menu) {
      case 0: {
        const dataVar = item
          ? { bus: item, journeyDataUrl: "/seatArrangementdirectdata.json" }
          : null;
        if (dataVar != null) {
          setDialogData(dataVar);
          setActiveJourneyId(item.JourneyID);
          setJourneyDialogOpen(true);
          setCurrentTab(0);
        }
        break;
      }
      case 1: {
        const dataVar = item ? { bus: item } : null;
        if (dataVar != null) {
          setDialogData(dataVar);
          setActiveJourneyId(item.JourneyID);
          setJourneyDialogOpen(true);
          setCurrentTab(1);
        }
        break;
      }
      case 2: {
        const dataVar = item
          ? { bus: item, journeyDataUrl: "/seatArrangementdirectdata.json" }
          : null;
        if (dataVar != null) {
          setDialogData(dataVar);
          setActiveJourneyId(item.JourneyID);
          setJourneyDialogOpen(true);
          setCurrentTab(2);
        }
        break;
      }
      case 3: {
        const dataVar = item
          ? { bus: item, journeyDataUrl: "/seatArrangementdirectdata.json" }
          : null;
        if (dataVar != null) {
          setDialogData(dataVar);
          setActiveJourneyId(item.JourneyID);
          setJourneyDialogOpen(true);
          setCurrentTab(3);
        }
        break;
      }
      case 4: {
        const dataVar = item
          ? { bus: item, journeyDataUrl: "/seatArrangementdirectdata.json" }
          : null;
        if (dataVar != null) {
          setDialogData(dataVar);
          setActiveJourneyId(item.JourneyID);
          setJourneyDialogOpen(true);
          setCurrentTab(4);
        }
        break;
      }
      case 5:
        break;
    }
  };

  const handleOnDialogClose = (data) => {
    // console.log(data)
    setJourneyDialogOpen(data.lastDailogOpenValue);
    setActiveJourneyId(null);
  };

  const handleConfirmDialogClose = (userConfirmed) => {
     setConfirmationResult(userConfirmed);
  }

   const isThisCardOpen = journeyDialogOpen && activeJourneyId === item?.JourneyID;


   console.log("isThisCardOpen in route card");
   console.log(isThisCardOpen);


  return (
    <div className="route-data-new-card-item-container">
      <div className="top-nav">
        <div className="vehivle-no-tab">
          <div className="v-plate">
            <div className="flip-button">
              <div className="flip-container flip-animation">
                <div className="flip-inner">
                  <div className="flip-front">
                    {" "}
                    {item ? item.FlipLine1 : ""}{" "}
                  </div>
                  <div className="flip-back">
                    {" "}
                    {item
                      ? item.FlipLine2 == ""
                        ? item.FlipLine1
                        : item.FlipLine2
                      : ""}{" "}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="route-data-new-card">
        <div className="route-data-main-section"  onClick={() => handleMenuClick(0)}>
          <div className="bus-name-type-amenities">
            <div className="coach-type">{item ? item.CoachType : ""}</div>
            <div className="route-name">{item ? item.CoachExternal : ""}</div>
            <div className="amenities-chips">
              {item
                ? item.Amenities
                  ? item.Amenities.slice(0, 4).map((amenities) => {
                      return (
                        <>
                          <div className="am-chips">
                            <img
                              title={amenities.AmenityName}
                              src={`/icons/amenities/${amenities.IconImage}`}
                              width="25px"
                            />
                          </div>
                        </>
                      );
                    })
                  : ""
                : ""}
            </div>
          </div>
          <div className="bus-time-duration">
            <div className="bus-timeings">
              <span> {item ? item.MBT : ""} </span>
              <span> {item ? item.MDT : ""} </span>
            </div>
            <div className="bus-durations">
              <div className="img-duration-content">
                <span className="duration"> {item ? item.Duration : ""} </span>
                <img src="/images/line_with_circles.svg" />
              </div>
            </div>
            <div className="no-of-seats">
              <div className="seats">
                <span>{item ? item.EmptySeatCount : ""} Seats Available</span>
                <span>3 Window Seats</span>
              </div>
            </div>
          </div>
          <div className="bus-pricing">
            <div>
              <small className="strike-price">
                {" "}
                &#8377; {item ? item.DisplayFare : ""}
              </small>
            </div>
            <div className="fair">
              {" "}
              &#8377;{" "}
              {item
                ? (
                    Number(item.DisplayFare) -
                    (Number(item.DisplayFare) * 15) / 100
                  ).toFixed(0)
                : ""}
            </div>
          </div>
        </div>

        <div className="route-small-screen-nav">
          <div className="rote-nav">
            <span onClick={() => handleMenuClick(4)}> About Bus </span>
            <span onClick={() => handleMenuClick(-1)}> Reviews </span>
            <span onClick={() => handleMenuClick(1)}>
              {" "}
              Boarding / Dropping Point{" "}
            </span>
            <span onClick={() => handleMenuClick(3)}> Bus Routes </span>
          </div>
        </div>

        <div className="route-data-nav">
          <div className="rote-nav">
            <span onClick={() => handleMenuClick(4)}> About Bus </span>
            <span onClick={() => handleMenuClick(-1)}> Reviews </span>
            <span onClick={() => handleMenuClick(1)}>
              {" "}
              Boarding / Dropping Point{" "}
            </span>
            <span onClick={() => handleMenuClick(3)}> Bus Routes </span>
          </div>
          <div className="route-nav-aminites">
            <div className="amenities-chips">
              {item
                ? item.Amenities
                  ? item.Amenities.slice(0, 4).map((amenities) => {
                      return (
                        <>
                          <div className="am-chips">
                            <img
                              title={amenities.AmenityName}
                              src={`/icons/amenities/${amenities.IconImage}`}
                              width="15px"
                            />
                          </div>
                        </>
                      );
                    })
                  : ""
                : ""}
            </div>
          </div>
          <div className="rote-rate">
            <span className="rating-icon">
              <CiStar />
            </span>
            <span> 4.5/5 </span>
          </div>
          <div className="rote-button">
            <button
              className="view-seats-button"
              onClick={() => handleMenuClick(0)}
            >
              View Seats
            </button>
          </div>
        </div>
      </div>

      {isSmallScreen ? <>
        { 
          globalData.isReturnJourneyExist ? <>

            <JourneyRoundTripDailogSmallScreen 

             dailogOnwardInputData={onwardDailogData}
              dailogReturnInputData={returnDailogData}
              open={isThisCardOpen}
              currentTab={currentTab}
              dialogClose={handleOnDialogClose}
              paymentUrl={paymentUrl}
              handleTabChangeInDialog = {handleTabChangeInDialog}
              clickedFrom={journeytype}



            />

          </> :
          <JourneyDailogSmallScreen
            dailogInputData={dialogData}
            open={isThisCardOpen}
            currentTab={currentTab}
            dialogClose={handleOnDialogClose}
            paymentUrl={paymentUrl}
          />




          



        }
        
      </> : (
        <>
          {globalData.isReturnJourneyExist ? (
            <JourneyRoundTripDailog
              dailogOnwardInputData={onwardDailogData}
              dailogReturnInputData={returnDailogData}
              open={isThisCardOpen}
              currentTab={currentTab}
              dialogClose={handleOnDialogClose}
              paymentUrl={paymentUrl}
              handleTabChangeInDialog = {handleTabChangeInDialog}
              clickedFrom={journeytype}
            />
          ) : (
            <JourneyDailog
              dailogInputData={dialogData}
              open={isThisCardOpen}
              currentTab={currentTab}
              dialogClose={handleOnDialogClose}
              paymentUrl={paymentUrl}
            />
          )}
        </>
      )}


       <DraggableDialog openDialog={showConfirmDialog} Message={confirmDialogMessage} handleCloseDialog={handleConfirmDialogClose} /> 
    </div>
  );
};

export default RouteCardNew;
